/**
 * The dashboard module's paths — spec §8.8.
 *
 * `/dashboard` is what `layout/nav-items.ts` already points its `dashboard` entry at,
 * gated on `dashboards:read`, and `/analytics` is the path the API'S OWN TILES link
 * into: `dashboards.tiles.ts` builds `utilization_today` with
 * `withQuery('/analytics', { period: 'day' })`. That makes the analytics path a
 * contract between two repositories rather than a local choice — renaming it here
 * without renaming it there produces a tile that navigates to a 404, which is exactly
 * the dead-tile failure rule 9 is about.
 *
 * Route paths stay in English while the UI defaults to French, for the reason
 * `nav-items.ts` gives: the address bar is not a translated surface.
 */

export const DASHBOARD_PATH = '/dashboard'
export const ANALYTICS_PATH = '/analytics'

export const DASHBOARD_QUERY_KEYS = {
  /** `day` | `week` | `month` | `custom`. */
  period: 'period',
  from: 'from',
  to: 'to',
  fleetId: 'fleet',
  /** `distance` | `engine_hours` | `all` — the heat map's segment. */
  segment: 'segment',
} as const

export function analyticsPath(params: Record<string, string | undefined> = {}): string {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) search.set(key, value)
  }
  const query = search.toString()
  return query.length === 0 ? ANALYTICS_PATH : `${ANALYTICS_PATH}?${query}`
}
